import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=ce1d6714&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports